import React from 'react'
import { Elements } from '@stripe/react-stripe-js'

import stripeAppearance from './stripeAppearance'

// Stable outer Elements provider for the whole v7 widget tree. Carries
// only appearance + fonts — no payment-specific options (mode, amount,
// paymentMethodTypes) — so it can host the AddressElement on Contact
// regardless of the chosen payment method, and so the per-method inner
// Elements (PaymentElement for card/bank, ECE for AP/GP) can mount
// inside it without conflict.
//
// Mirrors v6's StripeWrapper (donate_v6/StripeWrapper.jsx) — the
// pattern of nesting payment-specific Elements inside a
// fonts/appearance-only outer Elements is what makes the AddressElement
// → PaymentElement coupling work across step transitions.
const StripeWrapper = ({ stripePromise, stripeFonts, children }) =>
  <Elements
    stripe={stripePromise}
    options={{ fonts: stripeFonts, appearance: stripeAppearance() }}
  >
    {children}
  </Elements>

export default StripeWrapper
